import React from 'react'
import { Link } from 'react-router-dom'

const HomePage = () => {
	return (
		<div className="page">
			<img src="/kaloai.png" alt="KaloAI" className="app-logo" />

			<p>Aplikacja do śledzenia kalorii z pomocą sztucznej inteligencji.</p>

			<p>
				KaloAI to prosta aplikacja, która pomoże Ci kontrolować spożywane kalorie używając sztucznej inteligencji.
				Wystarczy zdjęcie posiłku, a AI automatycznie rozpozna składniki i powie ile kalorii zawiera.
			</p>

			<p>
				Jak to działa? Robisz zdjęcie jedzenia, AI analizuje składniki i oblicza kalorie automatycznie w kilka sekund.
				Nasza sztuczna inteligencja została wytrenowana na tysiącach zdjęć różnych potraw.
			</p>

			<p>
				Dlaczego KaloAI? To najszybszy sposób kontrolowania diety. Nie musisz ręcznie wpisywać składników czy szukać w
				bazach danych. Wystarczy jedno zdjęcie.
			</p>

			<p>
				KaloAI działa offline po pobraniu modeli AI. Twoje zdjęcia są przetwarzane lokalnie na urządzeniu, co chroni
				Twoją prywatność.{' '}
				<Link to="/privacy" className="router-link">
					Dowiedz się więcej o polityce prywatności
				</Link>
				.
			</p>

			<p>
				Aplikacja jest prosta w użyciu - każdy może z niej korzystać. Interfejs jest czysty i skupiony na szybkim
				liczeniu kalorii.
			</p>

			<div className="download-buttons">
				<h3>Pobierz aplikację</h3>
				<p>
					<span className="store-button disabled">Pobierz z Google Play</span>{' '}
					<span className="unavailable-text">obecnie niedostępne</span>
				</p>
				<p>
					<a href="#" className="store-button">
						Pobierz z App Store
					</a>
				</p>
			</div>
		</div>
	)
}

export default HomePage
